import { Route } from 'react-router-dom';
import CmsGlobal from '../pages/cms-global';
import { getValueByEnv } from '@/env';

const InjectType = { iframe: 3, microapp: 2 };

const CMS_URL = getValueByEnv({
  envDev: {
    seckill: 'http://seckillcms.jd.com/index.action',
  },
  envBeta: {
    seckill: 'http://seckillcms.jd.com/index.action',
  },
  envProd: {
    seckill: 'https://seckillcmsyx.jd.com/index.action',
  },
});

const globalcmsRoutes = [
  <Route
    key="/materials/cms-global/:channelId/seckill-cms"
    path="/materials/cms-global/:channelId/seckill-cms"
    component={function () {
      return <CmsGlobal injectType={InjectType.iframe} title="秒杀闪购CMS" url={CMS_URL.seckill} />;
    }}
  />,
];

export default globalcmsRoutes;
